module.exports = __webpack_public_path__ + "static/media/Home-BlueCircle1.91258841.svg";